module.exports = __webpack_public_path__ + "img/delete-red.1c443e9c.svg";